define(function(require, exports, module) {
    'use strict';

    var LogoutView = require('replacers/logout/logout.view');

    module.exports = LogoutView.extend({

        render: function() {
            this.$el.html(this.tmpl('logout', this.options));

            return this;
        }

    });
});